import { departments } from "data/authData";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import moment from "moment";

export const isNew = "is_new";
export const modalProfileUrlKey = "modal_profile";
export const NAOption = "N/A";

export const fileTypes = {
	TYPE_1: { name: "TYPE 1", key: "TYPE_1" },
};

export const fileColumns = [
	{
		name: "Effective Date",
		key: "effective_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		default_value: moment().format("YYYY-MM-DD"),
	},
	{
		name: "File Name",
		key: "file_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
	{
		name: "File Type",
		key: "file_type",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		[selectOptionsKeyName]: { type: arrType, list: Object.values(fileTypes) },
	},
	{
		name: "URL",
		key: modalProfileUrlKey,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
];

export const styleImgDepartmentCol = {
	name: "Department",
	key: "department",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: false, DISPLAY: false, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	[selectOptionsKeyName]: { type: arrType, list: Object.values(departments) },
};
export const modalProfileImagesAssocObj = "modalProfileImages";
export const modalProfileFileAssocObj = "modalProfileFiles";
